export const DictionaryPhotoshop_ko_KR = [
    {
        id: 1,
        label: 'Photoshop > Photoshop 정보...',
        placement: 'MenuBar',
        name: 'Photoshop 정보...',
    },
    {
        id: 10,
        label: '파일 > 새로 만들기...',
        placement: 'MenuBar',
        name: '새로 만들기...',
    },
    {
        id: 20,
        label: '파일 > 열기...',
        placement: 'MenuBar',
        name: '열기...',
    },
    {
        id: 22,
        label: '파일 > 스마트 오브젝트로 열기...',
        placement: 'MenuBar',
        name: '스마트 오브젝트로 열기...',
    },
    {
        id: 30,
        label: '파일 > 저장',
        placement: 'MenuBar',
        name: '저장',
    },
    {
        id: 31,
        label: '파일 > 닫기',
        placement: 'MenuBar',
        name: '닫기',
    },
    {
        id: 32,
        label: '파일 > 다른 이름으로 저장...',
        placement: 'MenuBar',
        name: '다른 이름으로 저장...',
    },
    {
        id: 33,
        label: '파일 > 사본 저장...',
        placement: 'MenuBar',
        name: '사본 저장...',
    },
    {
        id: 34,
        label: '파일 > 되돌리기',
        placement: 'MenuBar',
        name: '되돌리기',
    },
    {
        id: 36,
        label: 'Photoshop > Photoshop 종료',
        placement: 'MenuBar',
        name: 'Photoshop 종료',
    },
    {
        id: 37,
        label: '파일 > 모두 닫기',
        placement: 'MenuBar',
        name: '모두 닫기',
    },
    {
        id: 46,
        label: '파일 > 기타 항목 닫기',
        placement: 'MenuBar',
        name: '기타 항목 닫기',
    },
    {
        id: 101,
        label: '편집 > 실행 취소(O)',
        placement: 'MenuBar',
        name: '실행 취소(O)',
    },
    {
        id: 103,
        label: '편집 > 잘라내기',
        placement: 'MenuBar',
        name: '잘라내기',
    },
    {
        id: 104,
        label: '편집 > 복사',
        placement: 'MenuBar',
        name: '복사',
    },
    {
        id: 105,
        label: '편집 > 붙여넣기',
        placement: 'MenuBar',
        name: '붙여넣기',
    },
    {
        id: 106,
        label: '편집 > 지우기',
        placement: 'MenuBar',
        name: '지우기',
    },
    {
        id: 132,
        label: '편집 > 다시 실행(O)',
        placement: 'MenuBar',
        name: '다시 실행(O)',
    },
    {
        id: 133,
        label: '편집 > 마지막 상태 전환',
        placement: 'MenuBar',
        name: '마지막 상태 전환',
    },
    {
        id: 177,
        label: '파일 > 한 부 인쇄',
        placement: 'MenuBar',
        name: '한 부 인쇄',
    },
    {
        id: 1001,
        label: '창 > 정돈 > 새 창',
        placement: 'MenuBar',
        name: '새 창',
    },
    {
        id: 1002,
        label: '보기 > 눈금자',
        placement: 'MenuBar',
        name: '눈금자',
    },
    {
        id: 1004,
        label: '보기 > 확대',
        placement: 'MenuBar',
        name: '확대',
    },
    {
        id: 1005,
        label: '보기 > 축소',
        placement: 'MenuBar',
        name: '축소',
    },
    {
        id: 1006,
        label: '이미지 > 모드 > 비트맵(B)',
        placement: 'MenuBar',
        name: '비트맵(B)',
    },
    {
        id: 1007,
        label: '이미지 > 모드 > 회색 음영(G)',
        placement: 'MenuBar',
        name: '회색 음영(G)',
    },
    {
        id: 1008,
        label: '이미지 > 모드 > 이중톤(D)',
        placement: 'MenuBar',
        name: '이중톤(D)',
    },
    {
        id: 1009,
        label: '이미지 > 모드 > 인덱스 색상(I)',
        placement: 'MenuBar',
        name: '인덱스 색상(I)',
    },
    {
        id: 1010,
        label: '이미지 > 모드 > RGB 색상',
        placement: 'MenuBar',
        name: 'RGB 색상',
    },
    {
        id: 1011,
        label: '이미지 > 모드 > CMYK 색상',
        placement: 'MenuBar',
        name: 'CMYK 색상',
    },
    {
        id: 1014,
        label: '이미지 > 모드 > 다중 채널',
        placement: 'MenuBar',
        name: '다중 채널',
    },
    {
        id: 1016,
        label: '선택 > 선택 해제(D)',
        placement: 'MenuBar',
        name: '선택 해제(D)',
    },
    {
        id: 1017,
        label: '선택 > 모두(A)',
        placement: 'MenuBar',
        name: '모두(A)',
    },
    {
        id: 1018,
        label: '선택 > 반전',
        placement: 'MenuBar',
        name: '반전',
    },
    {
        id: 1019,
        label: '필터 > 마지막 필터',
        placement: 'MenuBar',
        name: '마지막 필터',
    },
    {
        id: 1021,
        label: '창 > 채널',
        placement: 'MenuBar',
        name: '채널',
    },
    {
        id: 1025,
        label: '창 > 브러시 설정',
        placement: 'MenuBar',
        name: '브러시 설정',
    },
    {
        id: 1029,
        label: '편집 > 브러시 사전 설정 정의...',
        placement: 'MenuBar',
        name: '브러시 사전 설정 정의...',
    },
    {
        id: 1030,
        label: '이미지 > 이미지 크기...',
        placement: 'MenuBar',
        name: '이미지 크기...',
    },
    {
        id: 1031,
        label: '이미지 > 캔버스 크기...',
        placement: 'MenuBar',
        name: '캔버스 크기...',
    },
    {
        id: 1032,
        label: '파일 > 포함 가져오기...',
        placement: 'MenuBar',
        name: '포함 가져오기...',
    },
    {
        id: 1033,
        label: '선택 > 선택 영역 확장',
        placement: 'MenuBar',
        name: '선택 영역 확장',
    },
    {
        id: 1034,
        label: '선택 > 유사 영역 선택',
        placement: 'MenuBar',
        name: '유사 영역 선택',
    },
    {
        id: 1035,
        label: '선택 > 수정 > 테두리...',
        placement: 'MenuBar',
        name: '테두리...',
    },
    {
        id: 1036,
        label: '선택 > 수정 > 페더...',
        placement: 'MenuBar',
        name: '페더...',
    },
    {
        id: 1037,
        label: '레이어 > 매트 > 언저리 제거...',
        placement: 'MenuBar',
        name: '언저리 제거...',
    },
    {
        id: 1038,
        label: '편집 > 패턴 정의...',
        placement: 'MenuBar',
        name: '패턴 정의...',
    },
    {
        id: 1040,
        label: '편집 > 특수 붙여넣기 > 안쪽에 붙여넣기',
        placement: 'MenuBar',
        name: '안쪽에 붙여넣기',
    },
    {
        id: 1042,
        label: '편집 > 칠...',
        placement: 'MenuBar',
        name: '칠...',
    },
    {
        id: 1043,
        label: '편집 > 획...',
        placement: 'MenuBar',
        name: '획...',
    },
    {
        id: 1044,
        label: '이미지 > 자르기',
        placement: 'MenuBar',
        name: '자르기',
    },
    {
        id: 1045,
        label: '이미지 > 모드 > 색상표...',
        placement: 'MenuBar',
        name: '색상표...',
    },
    {
        id: 1046,
        label: '창 > 색상',
        placement: 'MenuBar',
        name: '색상',
    },
    {
        id: 1052,
        label: '이미지 > 모드 > Lab 색상',
        placement: 'MenuBar',
        name: 'Lab 색상',
    },
    {
        id: 1055,
        label: '창 > 정보',
        placement: 'MenuBar',
        name: '정보',
    },
    {
        id: 1058,
        label: '창 > 복제 원본',
        placement: 'MenuBar',
        name: '복제 원본',
    },
    {
        id: 1065,
        label: '창 > 패스',
        placement: 'MenuBar',
        name: '패스',
    },
    {
        id: 1080,
        label: '이미지 > 재단...',
        placement: 'MenuBar',
        name: '재단...',
    },
    {
        id: 1081,
        label: '이미지 > 모두 나타내기',
        placement: 'MenuBar',
        name: '모두 나타내기',
    },
    {
        id: 1093,
        label: '이미지 > 트랩...',
        placement: 'MenuBar',
        name: '트랩...',
    },
    {
        id: 1098,
        label: '창 > 레이어',
        placement: 'MenuBar',
        name: '레이어',
    },
    {
        id: 1099,
        label: '레이어 > 새로 만들기 > 레이어...',
        placement: 'MenuBar',
        name: '레이어...',
    },
    {
        id: 1100,
        label: '레이어 > 삭제 > 레이어(L)',
        placement: 'MenuBar',
        name: '레이어(L)',
    },
    {
        id: 1103,
        label: '레이어 > 레이어 내용 옵션...',
        placement: 'MenuBar',
        name: '레이어 내용 옵션...',
    },
    {
        id: 1105,
        label: '보기 > 교정 인쇄 색상',
        placement: 'MenuBar',
        name: '교정 인쇄 색상',
    },
    {
        id: 1106,
        label: '보기 > 색상 영역 경고',
        placement: 'MenuBar',
        name: '색상 영역 경고',
    },
    {
        id: 1107,
        label: '편집 > 병합하여 복사',
        placement: 'MenuBar',
        name: '병합하여 복사',
    },
    {
        id: 1108,
        label: '선택 > 수정 > 매끄럽게...',
        placement: 'MenuBar',
        name: '매끄럽게...',
    },
    {
        id: 1109,
        label: '선택 > 수정 > 확대...',
        placement: 'MenuBar',
        name: '확대...',
    },
    {
        id: 1110,
        label: '선택 > 수정 > 축소...',
        placement: 'MenuBar',
        name: '축소...',
    },
    {
        id: 1111,
        label: '창 > 옵션',
        placement: 'MenuBar',
        name: '옵션',
    },
    {
        id: 1112,
        label: '보기 > 픽셀 종횡비 교정',
        placement: 'MenuBar',
        name: '픽셀 종횡비 교정',
    },
    {
        id: 1114,
        label: '레이어 > 레이어 숨기기',
        placement: 'MenuBar',
        name: '레이어 숨기기',
    },
    {
        id: 1115,
        label: '선택 > 선택 및 마스크...',
        placement: 'MenuBar',
        name: '선택 및 마스크...',
    },
    {
        id: 1119,
        label: '창 > 색상 견본',
        placement: 'MenuBar',
        name: '색상 견본',
    },
    {
        id: 1134,
        label: '이미지 > 복제...',
        placement: 'MenuBar',
        name: '복제...',
    },
    {
        id: 1135,
        label: '레이어 > 레이어 복제...',
        placement: 'MenuBar',
        name: '레이어 복제...',
    },
    {
        id: 1137,
        label: '파일 > 파일 정보...',
        placement: 'MenuBar',
        name: '파일 정보...',
    },
    {
        id: 1139,
        label: '레이어 > 보이는 레이어 병합',
        placement: 'MenuBar',
        name: '보이는 레이어 병합',
    },
    {
        id: 1141,
        label: '레이어 > 배경으로 이미지 병합',
        placement: 'MenuBar',
        name: '배경으로 이미지 병합',
    },
    {
        id: 1152,
        label: '선택 > 색상 범위...',
        placement: 'MenuBar',
        name: '색상 범위...',
    },
    {
        id: 1153,
        label: '이미지 > 이미지 적용...',
        placement: 'MenuBar',
        name: '이미지 적용...',
    },
    {
        id: 1154,
        label: '편집 > 희미하게 하기(D)...',
        placement: 'MenuBar',
        name: '희미하게 하기(D)...',
    },
    {
        id: 1156,
        label: '레이어 > 레이어 마스크 > 모두 숨기기',
        placement: 'MenuBar',
        name: '모두 숨기기',
    },
    {
        id: 1157,
        label: '레이어 > 레이어 마스크 > 모두 나타내기',
        placement: 'MenuBar',
        name: '모두 나타내기',
    },
    {
        id: 1158,
        label: '레이어 > 레이어 마스크 > 선택 항목 나타내기',
        placement: 'MenuBar',
        name: '선택 항목 나타내기',
    },
    {
        id: 1159,
        label: '레이어 > 레이어 마스크 > 사용 가능(B)',
        placement: 'MenuBar',
        name: '사용 가능(B)',
    },
    {
        id: 1161,
        label: '이미지 > 모드 > 8비트/채널(A)',
        placement: 'MenuBar',
        name: '8비트/채널(A)',
    },
    {
        id: 1162,
        label: '이미지 > 모드 > 16비트/채널(N)',
        placement: 'MenuBar',
        name: '16비트/채널(N)',
    },
    {
        id: 1163,
        label: '창 > 내비게이터',
        placement: 'MenuBar',
        name: '내비게이터',
    },
    {
        id: 1166,
        label: '레이어 > 레이어 병합(E)',
        placement: 'MenuBar',
        name: '레이어 병합(E)',
    },
    {
        id: 1167,
        label: '창 > 레이어 구성 요소',
        placement: 'MenuBar',
        name: '레이어 구성 요소',
    },
    {
        id: 1168,
        label: '레이어 > 레이어 마스크 > 선택 항목 숨기기',
        placement: 'MenuBar',
        name: '선택 항목 숨기기',
    },
    {
        id: 1169,
        label: '파일 > 자동화 > 드롭릿 만들기...',
        placement: 'MenuBar',
        name: '드롭릿 만들기...',
    },
    {
        id: 1170,
        label: '창 > 액션',
        placement: 'MenuBar',
        name: '액션',
    },
    {
        id: 1180,
        label: '파일 > 자동화 > 일괄 처리...',
        placement: 'MenuBar',
        name: '일괄 처리...',
    },
    {
        id: 1188,
        label: '창 > 타임라인',
        placement: 'MenuBar',
        name: '타임라인',
    },
    {
        id: 1190,
        label: '보기 > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: '보기 > 인쇄 크기',
        placement: 'MenuBar',
        name: '인쇄 크기',
    },
    {
        id: 1192,
        label: '보기 > 화면 크기에 맞게 조정',
        placement: 'MenuBar',
        name: '화면 크기에 맞게 조정',
    },
    {
        id: 1194,
        label: '창 > 도구',
        placement: 'MenuBar',
        name: '도구',
    },
    {
        id: 1195,
        label: '보기 > 화면 크기에 아트보드 맞추기',
        placement: 'MenuBar',
        name: '화면 크기에 아트보드 맞추기',
    },
    {
        id: 1199,
        label: '창 > 작업 내역',
        placement: 'MenuBar',
        name: '작업 내역',
    },
    {
        id: 1200,
        label: '선택 > 선택 영역 불러오기...',
        placement: 'MenuBar',
        name: '선택 영역 불러오기...',
    },
    {
        id: 1202,
        label: '보기 > 픽셀 종횡비 > 사용자 정의 픽셀 종횡비...',
        placement: 'MenuBar',
        name: '사용자 정의 픽셀 종횡비...',
    },
    {
        id: 1203,
        label: '보기 > 픽셀 종횡비 > 픽셀 종횡비 삭제...',
        placement: 'MenuBar',
        name: '픽셀 종횡비 삭제...',
    },
    {
        id: 1204,
        label: '보기 > 픽셀 종횡비 > 픽셀 종횡비 재설정...',
        placement: 'MenuBar',
        name: '픽셀 종횡비 재설정...',
    },
    {
        id: 1205,
        label: '보기 > 픽셀 종횡비 > 정사각형',
        placement: 'MenuBar',
        name: '정사각형',
    },
    {
        id: 1206,
        label: '이미지 > 모드 > 32비트/채널',
        placement: 'MenuBar',
        name: '32비트/채널',
    },
    {
        id: 1211,
        label: '편집 > 사전 설정 > 사전 설정 마이그레이션',
        placement: 'MenuBar',
        name: '사전 설정 마이그레이션',
    },
    {
        id: 1212,
        label: '편집 > 프로필 할당...',
        placement: 'MenuBar',
        name: '프로필 할당...',
    },
    {
        id: 1213,
        label: '편집 > 프로필로 변환(V)...',
        placement: 'MenuBar',
        name: '프로필로 변환(V)...',
    },
    {
        id: 1214,
        label: '편집 > 사전 설정 > 사전 설정 관리자...',
        placement: 'MenuBar',
        name: '사전 설정 관리자...',
    },
    {
        id: 1215,
        label: '편집 > Adobe PDF 사전 설정...',
        placement: 'MenuBar',
        name: 'Adobe PDF 사전 설정...',
    },
    {
        id: 1217,
        label: '보기 > 실제 크기',
        placement: 'MenuBar',
        name: '실제 크기',
    },
    {
        id: 1223,
        label: '문자 > 방향 > 가로',
        placement: 'MenuBar',
        name: '가로',
    },
    {
        id: 1224,
        label: '문자 > 방향 > 세로',
        placement: 'MenuBar',
        name: '세로',
    },
    {
        id: 1228,
        label: '문자 > 작업 패스 만들기',
        placement: 'MenuBar',
        name: '작업 패스 만들기',
    },
    {
        id: 1229,
        label: '문자 > 모양으로 변환',
        placement: 'MenuBar',
        name: '모양으로 변환',
    },
    {
        id: 1231,
        label: '레이어 > 정렬 > 위쪽 가장자리',
        placement: 'MenuBar',
        name: '위쪽 가장자리',
    },
    {
        id: 1232,
        label: '레이어 > 정렬 > 아래쪽 가장자리',
        placement: 'MenuBar',
        name: '아래쪽 가장자리',
    },
    {
        id: 1233,
        label: '레이어 > 정렬 > 수직 가운데',
        placement: 'MenuBar',
        name: '수직 가운데',
    },
    {
        id: 1234,
        label: '레이어 > 정렬 > 왼쪽 가장자리',
        placement: 'MenuBar',
        name: '왼쪽 가장자리',
    },
    {
        id: 1235,
        label: '레이어 > 정렬 > 오른쪽 가장자리',
        placement: 'MenuBar',
        name: '오른쪽 가장자리',
    },
    {
        id: 1236,
        label: '레이어 > 정렬 > 수평 가운데',
        placement: 'MenuBar',
        name: '수평 가운데',
    },
    {
        id: 1237,
        label: '편집 > 레이어 자동 맞춤...',
        placement: 'MenuBar',
        name: '레이어 자동 맞춤...',
    },
    {
        id: 1238,
        label: '편집 > 레이어 자동 혼합...',
        placement: 'MenuBar',
        name: '레이어 자동 혼합...',
    },
    {
        id: 1239,
        label: '레이어 > 분포 > 세로',
        placement: 'MenuBar',
        name: '세로',
    },
    {
        id: 1241,
        label: '레이어 > 분포 > 위쪽 가장자리',
        placement: 'MenuBar',
        name: '위쪽 가장자리',
    },
    {
        id: 1242,
        label: '레이어 > 분포 > 아래쪽 가장자리',
        placement: 'MenuBar',
        name: '아래쪽 가장자리',
    },
    {
        id: 1243,
        label: '레이어 > 분포 > 수직 가운데',
        placement: 'MenuBar',
        name: '수직 가운데',
    },
    {
        id: 1245,
        label: '레이어 > 분포 > 왼쪽 가장자리',
        placement: 'MenuBar',
        name: '왼쪽 가장자리',
    },
    {
        id: 1246,
        label: '레이어 > 분포 > 오른쪽 가장자리',
        placement: 'MenuBar',
        name: '오른쪽 가장자리',
    },
    {
        id: 1247,
        label: '레이어 > 분포 > 수평 가운데',
        placement: 'MenuBar',
        name: '수평 가운데',
    },
    {
        id: 1249,
        label: '레이어 > 분포 > 가로',
        placement: 'MenuBar',
        name: '가로',
    },
    {
        id: 1281,
        label: '선택 > 선택 영역 저장...',
        placement: 'MenuBar',
        name: '선택 영역 저장...',
    },
    {
        id: 1284,
        label: '보기 > 가로로 뒤집기',
        placement: 'MenuBar',
        name: '가로로 뒤집기',
    },
    {
        id: 1285,
        label: '보기 > 패턴 미리 보기',
        placement: 'MenuBar',
        name: '패턴 미리 보기',
    },
    {
        id: 1292,
        label: '레이어 > 레이어 마스크 > 투명도에서',
        placement: 'MenuBar',
        name: '투명도에서',
    },
    {
        id: 1295,
        label: '레이어 > 매트 > 색상 정화...',
        placement: 'MenuBar',
        name: '색상 정화...',
    },
    {
        id: 1297,
        label: '편집 > 특수 붙여넣기 > 제 자리에 붙여넣기',
        placement: 'MenuBar',
        name: '제 자리에 붙여넣기',
    },
    {
        id: 1299,
        label: '보기 > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: '레이어 > 레이어 스타일 > 그림자...',
        placement: 'MenuBar',
        name: '그림자...',
    },
    {
        id: 1302,
        label: '레이어 > 레이어 스타일 > 내부 그림자...',
        placement: 'MenuBar',
        name: '내부 그림자...',
    },
    {
        id: 1303,
        label: '레이어 > 레이어 스타일 > 외부 광선...',
        placement: 'MenuBar',
        name: '외부 광선...',
    },
    {
        id: 1304,
        label: '레이어 > 레이어 스타일 > 내부 광선...',
        placement: 'MenuBar',
        name: '내부 광선...',
    },
    {
        id: 1305,
        label: '레이어 > 레이어 스타일 > 경사와 엠보스...',
        placement: 'MenuBar',
        name: '경사와 엠보스...',
    },
    {
        id: 1306,
        label: '레이어 > 레이어 스타일 > 모든 효과 숨기기',
        placement: 'MenuBar',
        name: '모든 효과 숨기기',
    },
    {
        id: 1307,
        label: '레이어 > 레이어 스타일 > 전체 조명...',
        placement: 'MenuBar',
        name: '전체 조명...',
    },
    {
        id: 1308,
        label: '레이어 > 레이어 스타일 > 레이어 만들기',
        placement: 'MenuBar',
        name: '레이어 만들기',
    },
    {
        id: 1312,
        label: '레이어 > 레이어 스타일 > 새틴...',
        placement: 'MenuBar',
        name: '새틴...',
    },
    {
        id: 1313,
        label: '레이어 > 레이어 스타일 > 획...',
        placement: 'MenuBar',
        name: '획...',
    },
    {
        id: 1314,
        label: '레이어 > 레이어 스타일 > 레이어 스타일 복사',
        placement: 'MenuBar',
        name: '레이어 스타일 복사',
    },
    {
        id: 1315,
        label: '레이어 > 레이어 스타일 > 레이어 스타일 붙여넣기',
        placement: 'MenuBar',
        name: '레이어 스타일 붙여넣기',
    },
    {
        id: 1327,
        label: '레이어 > 레이어 스타일 > 효과 비율 조정...',
        placement: 'MenuBar',
        name: '효과 비율 조정...',
    },
    {
        id: 1331,
        label: '레이어 > 레이어 스타일 > 혼합 옵션...',
        placement: 'MenuBar',
        name: '혼합 옵션...',
    },
    {
        id: 1335,
        label: '레이어 > 레이어 스타일 > 색상 오버레이...',
        placement: 'MenuBar',
        name: '색상 오버레이...',
    },
    {
        id: 1336,
        label: '레이어 > 레이어 스타일 > 그레이디언트 오버레이...',
        placement: 'MenuBar',
        name: '그레이디언트 오버레이...',
    },
    {
        id: 1337,
        label: '레이어 > 레이어 스타일 > 패턴 오버레이...',
        placement: 'MenuBar',
        name: '패턴 오버레이...',
    },
    {
        id: 1339,
        label: '레이어 > 레이어 스타일 > 레이어 스타일 지우기',
        placement: 'MenuBar',
        name: '레이어 스타일 지우기',
    },
    {
        id: 1355,
        label: '창 > 메모',
        placement: 'MenuBar',
        name: '메모',
    },
    {
        id: 1382,
        label: '창 > 막대 그래프',
        placement: 'MenuBar',
        name: '막대 그래프',
    },
    {
        id: 1396,
        label: '창 > 브러시',
        placement: 'MenuBar',
        name: '브러시',
    },
    {
        id: 1429,
        label: '플러그인 > 플러그인 패널',
        placement: 'MenuBar',
        name: '플러그인 패널',
    },
    {
        id: 1430,
        label: '플러그인 > 플러그인 찾아보기...',
        placement: 'MenuBar',
        name: '플러그인 찾아보기...',
    },
    {
        id: 1431,
        label: '플러그인 > 플러그인 관리...',
        placement: 'MenuBar',
        name: '플러그인 관리...',
    },
    {
        id: 1460,
        label: '선택 > 초점 영역...',
        placement: 'MenuBar',
        name: '초점 영역...',
    },
    {
        id: 1461,
        label: '선택 > 피사체',
        placement: 'MenuBar',
        name: '피사체',
    },
    {
        id: 1462,
        label: '선택 > 하늘',
        placement: 'MenuBar',
        name: '하늘',
    },
    {
        id: 1502,
        label: '파일 > 가져오기 > 장치의 이미지...',
        placement: 'MenuBar',
        name: '장치의 이미지...',
    },
    {
        id: 1503,
        label: '파일 > iPhone 또는 iPad에서 가져오기',
        placement: 'MenuBar',
        name: 'iPhone 또는 iPad에서 가져오기',
    },
    {
        id: 1510,
        label: '편집 > 내용 인식 채우기...',
        placement: 'MenuBar',
        name: '내용 인식 채우기...',
    },
    {
        id: 1520,
        label: '파일 > Bridge에서 찾아보기...',
        placement: 'MenuBar',
        name: 'Bridge에서 찾아보기...',
    },
    {
        id: 1522,
        label: '문자 > Adobe Fonts에서의 추가 글꼴...',
        placement: 'MenuBar',
        name: 'Adobe Fonts에서의 추가 글꼴...',
    },
    {
        id: 1530,
        label: '파일 > 닫은 후 Bridge로 이동...',
        placement: 'MenuBar',
        name: '닫은 후 Bridge로 이동...',
    },
    {
        id: 1613,
        label: '편집 > 원격 연결...',
        placement: 'MenuBar',
        name: '원격 연결...',
    },
    {
        id: 1676,
        label: '파일 > 스크립트 > 찾아보기...',
        placement: 'MenuBar',
        name: '찾아보기...',
    },
    {
        id: 1695,
        label: '파일 > 내보내기 > 웹용으로 저장...',
        placement: 'MenuBar',
        name: '웹용으로 저장...',
    },
    {
        id: 1696,
        label: '파일 > 자동화 > PDF 프레젠테이션...',
        placement: 'MenuBar',
        name: 'PDF 프레젠테이션...',
    },
    {
        id: 1701,
        label: '이미지 > 조정 > 반전',
        placement: 'MenuBar',
        name: '반전',
    },
    {
        id: 1702,
        label: '이미지 > 조정 > 균일화',
        placement: 'MenuBar',
        name: '균일화',
    },
    {
        id: 1703,
        label: '이미지 > 조정 > 한계값...',
        placement: 'MenuBar',
        name: '한계값...',
    },
    {
        id: 1704,
        label: '이미지 > 조정 > 포스터화...',
        placement: 'MenuBar',
        name: '포스터화...',
    },
    {
        id: 1750,
        label: '편집 > 생성형 채우기...',
        placement: 'MenuBar',
        name: '생성형 채우기...',
    },
    {
        id: 1771,
        label: '편집 > 이미지 생성...',
        placement: 'MenuBar',
        name: '이미지 생성...',
    },
    {
        id: 1776,
        label: '이미지 > 생성형 업스케일...',
        placement: 'MenuBar',
        name: '생성형 업스케일...',
    },
    {
        id: 1777,
        label: '필터 > AI 노이즈 제거…',
        placement: 'MenuBar',
        name: 'AI 노이즈 제거…',
    },
    {
        id: 1778,
        label: '필터 > AI 선명 효과…',
        placement: 'MenuBar',
        name: 'AI 선명 효과…',
    },
    {
        id: 1801,
        label: '이미지 > 조정 > 레벨...',
        placement: 'MenuBar',
        name: '레벨...',
    },
    {
        id: 1802,
        label: '이미지 > 조정 > 곡선...',
        placement: 'MenuBar',
        name: '곡선...',
    },
    {
        id: 1803,
        label: '이미지 > 조정 > 밝기/대비...',
        placement: 'MenuBar',
        name: '밝기/대비...',
    },
    {
        id: 1804,
        label: '이미지 > 조정 > 색상 균형...',
        placement: 'MenuBar',
        name: '색상 균형...',
    },
    {
        id: 1805,
        label: '이미지 > 조정 > 색조/채도...',
        placement: 'MenuBar',
        name: '색조/채도...',
    },
    {
        id: 1806,
        label: '이미지 > 조정 > 색상 대체...',
        placement: 'MenuBar',
        name: '색상 대체...',
    },
    {
        id: 1807,
        label: '이미지 > 조정 > 선택 색상...',
        placement: 'MenuBar',
        name: '선택 색상...',
    },
    {
        id: 1808,
        label: '이미지 > 자동 톤',
        placement: 'MenuBar',
        name: '자동 톤',
    },
    {
        id: 1809,
        label: '이미지 > 조정 > 채도 감소',
        placement: 'MenuBar',
        name: '채도 감소',
    },
    {
        id: 1810,
        label: '이미지 > 자동 대비',
        placement: 'MenuBar',
        name: '자동 대비',
    },
    {
        id: 1817,
        label: '이미지 > 자동 색상',
        placement: 'MenuBar',
        name: '자동 색상',
    },
    {
        id: 1822,
        label: '이미지 > 조정 > 색상 일치...',
        placement: 'MenuBar',
        name: '색상 일치...',
    },
    {
        id: 1824,
        label: '이미지 > 조정 > 흑백...',
        placement: 'MenuBar',
        name: '흑백...',
    },
    {
        id: 1827,
        label: '이미지 > 조정 > 생동감...',
        placement: 'MenuBar',
        name: '생동감...',
    },
    {
        id: 1900,
        label: '이미지 > 연산...',
        placement: 'MenuBar',
        name: '연산...',
    },
    {
        id: 1942,
        label: '레이어 > 새로 만들기 > 배경',
        placement: 'MenuBar',
        name: '배경',
    },
    {
        id: 1943,
        label: '선택 > 다시 선택',
        placement: 'MenuBar',
        name: '다시 선택',
    },
    {
        id: 1953,
        label: '레이어 > 벡터 마스크 > 모두 숨기기',
        placement: 'MenuBar',
        name: '모두 숨기기',
    },
    {
        id: 1954,
        label: '레이어 > 벡터 마스크 > 모두 나타내기',
        placement: 'MenuBar',
        name: '모두 나타내기',
    },
    {
        id: 1955,
        label: '레이어 > 벡터 마스크 > 현재 패스',
        placement: 'MenuBar',
        name: '현재 패스',
    },
    {
        id: 1956,
        label: '레이어 > 벡터 마스크 > 삭제',
        placement: 'MenuBar',
        name: '삭제',
    },
    {
        id: 1957,
        label: '레이어 > 래스터화 > 벡터 마스크',
        placement: 'MenuBar',
        name: '벡터 마스크',
    },
    {
        id: 1959,
        label: '레이어 > 벡터 마스크 > 사용 가능(B)',
        placement: 'MenuBar',
        name: '사용 가능(B)',
    },
    {
        id: 1971,
        label: '선택 > 선택 영역 변형',
        placement: 'MenuBar',
        name: '선택 영역 변형',
    },
    {
        id: 2101,
        label: '파일 > 인쇄...',
        placement: 'MenuBar',
        name: '인쇄...',
    },
    {
        id: 2103,
        label: '파일 > 최근 파일 열기 > 최근 파일 목록 지우기',
        placement: 'MenuBar',
        name: '최근 파일 목록 지우기',
    },
    {
        id: 2109,
        label: '레이어 > 벡터 마스크 > 연결',
        placement: 'MenuBar',
        name: '연결',
    },
    {
        id: 2201,
        label: '편집 > 변형 > 비율',
        placement: 'MenuBar',
        name: '비율',
    },
    {
        id: 2202,
        label: '편집 > 변형 > 기울이기',
        placement: 'MenuBar',
        name: '기울이기',
    },
    {
        id: 2203,
        label: '편집 > 변형 > 원근',
        placement: 'MenuBar',
        name: '원근',
    },
    {
        id: 2204,
        label: '편집 > 변형 > 왜곡',
        placement: 'MenuBar',
        name: '왜곡',
    },
    {
        id: 2205,
        label: '편집 > 변형 > 회전',
        placement: 'MenuBar',
        name: '회전',
    },
    {
        id: 2207,
        label: '편집 > 자유 변형',
        placement: 'MenuBar',
        name: '자유 변형',
    },
    {
        id: 2208,
        label: '편집 > 변형 > 180도 회전',
        placement: 'MenuBar',
        name: '180도 회전',
    },
    {
        id: 2209,
        label: '편집 > 변형 > 시계 방향으로 90° 회전',
        placement: 'MenuBar',
        name: '시계 방향으로 90° 회전',
    },
    {
        id: 2210,
        label: '편집 > 변형 > 시계 반대 방향으로 90° 회전',
        placement: 'MenuBar',
        name: '시계 반대 방향으로 90° 회전',
    },
    {
        id: 2211,
        label: '편집 > 변형 > 가로로 뒤집기',
        placement: 'MenuBar',
        name: '가로로 뒤집기',
    },
    {
        id: 2212,
        label: '편집 > 변형 > 세로로 뒤집기',
        placement: 'MenuBar',
        name: '세로로 뒤집기',
    },
    {
        id: 2217,
        label: '편집 > 변형 > 반복',
        placement: 'MenuBar',
        name: '반복',
    },
    {
        id: 2218,
        label: '문자 > 텍스트 뒤틀기...',
        placement: 'MenuBar',
        name: '텍스트 뒤틀기...',
    },
    {
        id: 2219,
        label: '편집 > 변형 > 뒤틀기',
        placement: 'MenuBar',
        name: '뒤틀기',
    },
    {
        id: 2220,
        label: '편집 > 내용 인식 비율',
        placement: 'MenuBar',
        name: '내용 인식 비율',
    },
    {
        id: 2221,
        label: '편집 > 퍼펫 뒤틀기',
        placement: 'MenuBar',
        name: '퍼펫 뒤틀기',
    },
    {
        id: 2224,
        label: '필터 > 흐림 효과 갤러리 > 조리개 흐림 효과...',
        placement: 'MenuBar',
        name: '조리개 흐림 효과...',
    },
    {
        id: 2225,
        label: '필터 > 흐림 효과 갤러리 > 필드 흐림 효과...',
        placement: 'MenuBar',
        name: '필드 흐림 효과...',
    },
    {
        id: 2226,
        label: '필터 > 흐림 효과 갤러리 > 기울기-이동...',
        placement: 'MenuBar',
        name: '기울기-이동...',
    },
    {
        id: 2227,
        label: '필터 > 흐림 효과 갤러리 > 경로 흐림 효과...',
        placement: 'MenuBar',
        name: '경로 흐림 효과...',
    },
    {
        id: 2229,
        label: '필터 > 흐림 효과 갤러리 > 회전 흐림 효과...',
        placement: 'MenuBar',
        name: '회전 흐림 효과...',
    },
    {
        id: 2231,
        label: '필터 > 렌더 > 불꽃...',
        placement: 'MenuBar',
        name: '불꽃...',
    },
    {
        id: 2232,
        label: '필터 > 렌더 > 사진 프레임...',
        placement: 'MenuBar',
        name: '사진 프레임...',
    },
    {
        id: 2233,
        label: '필터 > 렌더 > 나무...',
        placement: 'MenuBar',
        name: '나무...',
    },
    {
        id: 2250,
        label: '편집 > 변형 > 뒤틀기를 수평으로 분할',
        placement: 'MenuBar',
        name: '뒤틀기를 수평으로 분할',
    },
    {
        id: 2251,
        label: '편집 > 변형 > 뒤틀기를 수직으로 분할',
        placement: 'MenuBar',
        name: '뒤틀기를 수직으로 분할',
    },
    {
        id: 2252,
        label: '편집 > 변형 > 뒤틀기를 십자형으로 분할',
        placement: 'MenuBar',
        name: '뒤틀기를 십자형으로 분할',
    },
    {
        id: 2253,
        label: '편집 > 변형 > 뒤틀기 분할 제거',
        placement: 'MenuBar',
        name: '뒤틀기 분할 제거',
    },
    {
        id: 2254,
        label: '편집 > 변형 > 안내선 켜기/끄기',
        placement: 'MenuBar',
        name: '안내선 켜기/끄기',
    },
    {
        id: 2255,
        label: '편집 > 변형 > 뒤틀기 기준점 전환',
        placement: 'MenuBar',
        name: '뒤틀기 기준점 전환',
    },
    {
        id: 2260,
        label: '편집 > 하늘 대체...',
        placement: 'MenuBar',
        name: '하늘 대체...',
    },
    {
        id: 2304,
        label: 'Photoshop > 환경 설정 > 성능...',
        placement: 'MenuBar',
        name: '성능...',
    },
    {
        id: 2311,
        label: 'Photoshop > 환경 설정 > 일반...',
        placement: 'MenuBar',
        name: '일반...',
    },
    {
        id: 2312,
        label: 'Photoshop > 환경 설정 > 커서...',
        placement: 'MenuBar',
        name: '커서...',
    },
    {
        id: 2313,
        label: 'Photoshop > 환경 설정 > 투명도와 색상 영역...',
        placement: 'MenuBar',
        name: '투명도와 색상 영역...',
    },
    {
        id: 2314,
        label: 'Photoshop > 환경 설정 > 단위와 눈금자...',
        placement: 'MenuBar',
        name: '단위와 눈금자...',
    },
    {
        id: 2315,
        label: 'Photoshop > 환경 설정 > 안내선, 그리드 및 분할 영역...',
        placement: 'MenuBar',
        name: '안내선, 그리드 및 분할 영역...',
    },
    {
        id: 2316,
        label: 'Photoshop > 환경 설정 > 플러그인...',
        placement: 'MenuBar',
        name: '플러그인...',
    },
    {
        id: 2317,
        label: 'Photoshop > 환경 설정 > 파일 처리...',
        placement: 'MenuBar',
        name: '파일 처리...',
    },
    {
        id: 2322,
        label: 'Photoshop > 환경 설정 > 문자...',
        placement: 'MenuBar',
        name: '문자...',
    },
    {
        id: 2323,
        label: 'Photoshop > 환경 설정 > 인터페이스...',
        placement: 'MenuBar',
        name: '인터페이스...',
    },
    {
        id: 2324,
        label: 'Photoshop > 환경 설정 > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > 환경 설정 > 기술 미리 보기...',
        placement: 'MenuBar',
        name: '기술 미리 보기...',
    },
    {
        id: 2328,
        label: 'Photoshop > 환경 설정 > 스크래치 디스크...',
        placement: 'MenuBar',
        name: '스크래치 디스크...',
    },
    {
        id: 2329,
        label: 'Photoshop > 환경 설정 > 작업 내역 및 Content Credentials(H)...',
        placement: 'MenuBar',
        name: '작업 내역 및 Content Credentials(H)...',
    },
    {
        id: 2330,
        label: 'Photoshop > 환경 설정 > 도구...',
        placement: 'MenuBar',
        name: '도구...',
    },
    {
        id: 2331,
        label: 'Photoshop > 환경 설정 > 작업 영역...',
        placement: 'MenuBar',
        name: '작업 영역...',
    },
    {
        id: 2332,
        label: 'Photoshop > 환경 설정 > 내보내기...',
        placement: 'MenuBar',
        name: '내보내기...',
    },
    {
        id: 2332,
        label: '파일 > 내보내기 > 내보내기 기본 설정...',
        placement: 'MenuBar',
        name: '내보내기 기본 설정...',
    },
    {
        id: 2333,
        label: 'Photoshop > 환경 설정 > 향상된 컨트롤...',
        placement: 'MenuBar',
        name: '향상된 컨트롤...',
    },
    {
        id: 2335,
        label: 'Photoshop > 환경 설정 > 이미지 처리...',
        placement: 'MenuBar',
        name: '이미지 처리...',
    },
    {
        id: 2337,
        label: 'Photoshop > 환경 설정 > 알림...',
        placement: 'MenuBar',
        name: '알림...',
    },
    {
        id: 2344,
        label: '편집 > 색상 설정...',
        placement: 'MenuBar',
        name: '색상 설정...',
    },
    {
        id: 2345,
        label: '편집 > OpenColorIO 설정...',
        placement: 'MenuBar',
        name: 'OpenColorIO 설정...',
    },
    {
        id: 2361,
        label: '편집 > 제거 > 작업 내역',
        placement: 'MenuBar',
        name: '작업 내역',
    },
    {
        id: 2701,
        label: '레이어 > 매트 > 검정 매트 제거',
        placement: 'MenuBar',
        name: '검정 매트 제거',
    },
    {
        id: 2703,
        label: '레이어 > 매트 > 흰색 매트 제거',
        placement: 'MenuBar',
        name: '흰색 매트 제거',
    },
    {
        id: 2711,
        label: '레이어 > 정돈 > 맨 앞으로 가져오기',
        placement: 'MenuBar',
        name: '맨 앞으로 가져오기',
    },
    {
        id: 2712,
        label: '레이어 > 정돈 > 앞으로 가져오기',
        placement: 'MenuBar',
        name: '앞으로 가져오기',
    },
    {
        id: 2713,
        label: '레이어 > 정돈 > 뒤로 보내기',
        placement: 'MenuBar',
        name: '뒤로 보내기',
    },
    {
        id: 2714,
        label: '레이어 > 정돈 > 맨 뒤로 보내기',
        placement: 'MenuBar',
        name: '맨 뒤로 보내기',
    },
    {
        id: 2715,
        label: '레이어 > 정돈 > 반전',
        placement: 'MenuBar',
        name: '반전',
    },
    {
        id: 2769,
        label: '레이어 > 스마트 필터 > 스마트 필터 사용 불가',
        placement: 'MenuBar',
        name: '스마트 필터 사용 불가',
    },
    {
        id: 2770,
        label: '레이어 > 스마트 필터 > 스마트 필터 지우기',
        placement: 'MenuBar',
        name: '스마트 필터 지우기',
    },
    {
        id: 2802,
        label: '보기 > 교정 인쇄 설정 > 사용자 정의...',
        placement: 'MenuBar',
        name: '사용자 정의...',
    },
    {
        id: 2803,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 CMYK',
        placement: 'MenuBar',
        name: '작업 중인 CMYK',
    },
    {
        id: 2804,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 청록 플레이트',
        placement: 'MenuBar',
        name: '작업 중인 청록 플레이트',
    },
    {
        id: 2805,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 마젠타 플레이트',
        placement: 'MenuBar',
        name: '작업 중인 마젠타 플레이트',
    },
    {
        id: 2806,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 노랑 플레이트',
        placement: 'MenuBar',
        name: '작업 중인 노랑 플레이트',
    },
    {
        id: 2807,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 검정 플레이트',
        placement: 'MenuBar',
        name: '작업 중인 검정 플레이트',
    },
    {
        id: 2808,
        label: '보기 > 교정 인쇄 설정 > 작업 중인 CMY 플레이트',
        placement: 'MenuBar',
        name: '작업 중인 CMY 플레이트',
    },
    {
        id: 2809,
        label: '보기 > 교정 인쇄 설정 > 레거시 Macintosh RGB(감마 1.8)',
        placement: 'MenuBar',
        name: '레거시 Macintosh RGB(감마 1.8)',
    },
    {
        id: 2810,
        label: '보기 > 교정 인쇄 설정 > 인터넷 표준 RGB(sRGB)',
        placement: 'MenuBar',
        name: '인터넷 표준 RGB(sRGB)',
    },
    {
        id: 2811,
        label: '보기 > 교정 인쇄 설정 > 모니터 RGB',
        placement: 'MenuBar',
        name: '모니터 RGB',
    },
    {
        id: 2815,
        label: '보기 > 교정 인쇄 설정 > 색맹 - 적색맹 유형',
        placement: 'MenuBar',
        name: '색맹 - 적색맹 유형',
    },
    {
        id: 2816,
        label: '보기 > 교정 인쇄 설정 > 색맹 - 녹색맹 유형',
        placement: 'MenuBar',
        name: '색맹 - 녹색맹 유형',
    },
    {
        id: 2820,
        label: '이미지 > 분석 > 눈금자 도구',
        placement: 'MenuBar',
        name: '눈금자 도구',
    },
    {
        id: 2830,
        label: '이미지 > 분석 > 비율 표시자 가져오기...',
        placement: 'MenuBar',
        name: '비율 표시자 가져오기...',
    },
    {
        id: 2841,
        label: '이미지 > 분석 > 측정 비율 설정 > 기본값(D)',
        placement: 'MenuBar',
        name: '기본값(D)',
    },
    {
        id: 2842,
        label: '이미지 > 분석 > 측정 비율 설정 > 사용자 정의(C)...',
        placement: 'MenuBar',
        name: '사용자 정의(C)...',
    },
    {
        id: 2851,
        label: '이미지 > 분석 > 데이터 포인트 선택 > 사용자 정의(C)...',
        placement: 'MenuBar',
        name: '사용자 정의(C)...',
    },
    {
        id: 2860,
        label: '이미지 > 분석 > 측정 기록',
        placement: 'MenuBar',
        name: '측정 기록',
    },
    {
        id: 2880,
        label: '창 > 측정 로그',
        placement: 'MenuBar',
        name: '측정 로그',
    },
    {
        id: 2912,
        label: '편집 > 제거 > 클립보드',
        placement: 'MenuBar',
        name: '클립보드',
    },
    {
        id: 2915,
        label: '편집 > 제거 > 모두',
        placement: 'MenuBar',
        name: '모두',
    },
    {
        id: 2920,
        label: '편집 > 제거 > 비디오 캐시',
        placement: 'MenuBar',
        name: '비디오 캐시',
    },
    {
        id: 2939,
        label: '창 > 작업 영역 > 작업 영역 잠그기(L)',
        placement: 'MenuBar',
        name: '작업 영역 잠그기(L)',
    },
    {
        id: 2940,
        label: '보기 > 안내선 > 안내선 잠그기',
        placement: 'MenuBar',
        name: '안내선 잠그기',
    },
    {
        id: 2950,
        label: '보기 > 안내선 > 안내선 지우기',
        placement: 'MenuBar',
        name: '안내선 지우기',
    },
    {
        id: 2951,
        label: '레이어 > 삭제 > 숨겨진 레이어',
        placement: 'MenuBar',
        name: '숨겨진 레이어',
    },
    {
        id: 2952,
        label: '보기 > 안내선 > 선택한 아트보드 안내선 지우기',
        placement: 'MenuBar',
        name: '선택한 아트보드 안내선 지우기',
    },
    {
        id: 2953,
        label: '보기 > 안내선 > 캔버스 안내선 지우기',
        placement: 'MenuBar',
        name: '캔버스 안내선 지우기',
    },
    {
        id: 2956,
        label: '레이어 > 새로 만들기 > 레이어에서 그룹 만들기...',
        placement: 'MenuBar',
        name: '레이어에서 그룹 만들기...',
    },
    {
        id: 2957,
        label: '레이어 > 레이어 잠그기...',
        placement: 'MenuBar',
        name: '레이어 잠그기...',
    },
    {
        id: 2958,
        label: '레이어 > 레이어 그룹화',
        placement: 'MenuBar',
        name: '레이어 그룹화',
    },
    {
        id: 2959,
        label: '레이어 > 레이어 그룹 해제',
        placement: 'MenuBar',
        name: '레이어 그룹 해제',
    },
    {
        id: 2960,
        label: '레이어 > 연결된 레이어 선택',
        placement: 'MenuBar',
        name: '연결된 레이어 선택',
    },
    {
        id: 2961,
        label: '레이어 > 레이어 연결',
        placement: 'MenuBar',
        name: '레이어 연결',
    },
    {
        id: 2962,
        label: '선택 > 모든 레이어',
        placement: 'MenuBar',
        name: '모든 레이어',
    },
    {
        id: 2963,
        label: '선택 > 레이어 선택 해제',
        placement: 'MenuBar',
        name: '레이어 선택 해제',
    },
    {
        id: 2967,
        label: '보기 > 분할 영역 잠그기',
        placement: 'MenuBar',
        name: '분할 영역 잠그기',
    },
    {
        id: 2969,
        label: '보기 > 분할 영역 지우기',
        placement: 'MenuBar',
        name: '분할 영역 지우기',
    },
    {
        id: 2970,
        label: '레이어 > 새로 만들기 > 복사한 레이어',
        placement: 'MenuBar',
        name: '복사한 레이어',
    },
    {
        id: 2971,
        label: '레이어 > 새로 만들기 > 오린 레이어',
        placement: 'MenuBar',
        name: '오린 레이어',
    },
    {
        id: 2972,
        label: '레이어 > 클리핑 마스크 만들기',
        placement: 'MenuBar',
        name: '클리핑 마스크 만들기',
    },
    {
        id: 2976,
        label: '레이어 > 새로 만들기 > 그룹...',
        placement: 'MenuBar',
        name: '그룹...',
    },
    {
        id: 2980,
        label: '레이어 > 스마트 오브젝트 > 스마트 오브젝트로 변환',
        placement: 'MenuBar',
        name: '스마트 오브젝트로 변환',
    },
    {
        id: 2981,
        label: '레이어 > 스마트 오브젝트 > 복사를 통해 새 스마트 오브젝트 만들기',
        placement: 'MenuBar',
        name: '복사를 통해 새 스마트 오브젝트 만들기',
    },
    {
        id: 2982,
        label: '선택 > 레이어 찾기',
        placement: 'MenuBar',
        name: '레이어 찾기',
    },
    {
        id: 2983,
        label: '레이어 > 레이어 이름 바꾸기...',
        placement: 'MenuBar',
        name: '레이어 이름 바꾸기...',
    },
    {
        id: 2986,
        label: '선택 > 레이어 격리',
        placement: 'MenuBar',
        name: '레이어 격리',
    },
    {
        id: 2991,
        label: '이미지 > 이미지 회전 > 90° 시계 방향',
        placement: 'MenuBar',
        name: '90° 시계 방향',
    },
    {
        id: 2992,
        label: '이미지 > 이미지 회전 > 90° 시계 반대 방향',
        placement: 'MenuBar',
        name: '90° 시계 반대 방향',
    },
    {
        id: 2993,
        label: '이미지 > 이미지 회전 > 180도 회전',
        placement: 'MenuBar',
        name: '180도 회전',
    },
    {
        id: 2994,
        label: '이미지 > 이미지 회전 > 임의...',
        placement: 'MenuBar',
        name: '임의...',
    },
    {
        id: 2996,
        label: '이미지 > 이미지 회전 > 캔버스 가로로 뒤집기',
        placement: 'MenuBar',
        name: '캔버스 가로로 뒤집기',
    },
    {
        id: 2997,
        label: '이미지 > 이미지 회전 > 캔버스 세로로 뒤집기',
        placement: 'MenuBar',
        name: '캔버스 세로로 뒤집기',
    },
    {
        id: 3056,
        label: '이미지 > 조정 > 채널 혼합...',
        placement: 'MenuBar',
        name: '채널 혼합...',
    },
    {
        id: 3062,
        label: '이미지 > 조정 > 그레이디언트 맵...',
        placement: 'MenuBar',
        name: '그레이디언트 맵...',
    },
    {
        id: 3063,
        label: '이미지 > 조정 > 포토 필터...',
        placement: 'MenuBar',
        name: '포토 필터...',
    },
    {
        id: 3065,
        label: '이미지 > 조정 > 어두운 영역/밝은 영역...',
        placement: 'MenuBar',
        name: '어두운 영역/밝은 영역...',
    },
    {
        id: 3066,
        label: '이미지 > 조정 > 색상 검색...',
        placement: 'MenuBar',
        name: '색상 검색...',
    },
    {
        id: 3067,
        label: '이미지 > 조정 > 노출...',
        placement: 'MenuBar',
        name: '노출...',
    },
    {
        id: 3076,
        label: '레이어 > 스마트 필터 > 필터 마스크 사용 불가',
        placement: 'MenuBar',
        name: '필터 마스크 사용 불가',
    },
    {
        id: 3083,
        label: '레이어 > 새 조정 레이어 > 노출...',
        placement: 'MenuBar',
        name: '노출...',
    },
    {
        id: 3085,
        label: '레이어 > 새 조정 레이어 > 색상 및 활기…',
        placement: 'MenuBar',
        name: '색상 및 활기…',
    },
    {
        id: 3090,
        label: '파일 > 연결 가져오기...',
        placement: 'MenuBar',
        name: '연결 가져오기...',
    },
    {
        id: 3091,
        label: '레이어 > 스마트 오브젝트 > Finder에 나타내기',
        placement: 'MenuBar',
        name: 'Finder에 나타내기',
    },
    {
        id: 3092,
        label: '파일 > 패키지...',
        placement: 'MenuBar',
        name: '패키지...',
    },
    {
        id: 3098,
        label: '파일 > 자동화 > 생성기 플러그인',
        placement: 'MenuBar',
        name: '생성기 플러그인',
    },
    {
        id: 3187,
        label: '창 > 스타일',
        placement: 'MenuBar',
        name: '스타일',
    },
    {
        id: 3300,
        label: '문자 > 패널 > 문자 패널',
        placement: 'MenuBar',
        name: '문자 패널',
    },
    {
        id: 3300,
        label: '창 > 문자',
        placement: 'MenuBar',
        name: '문자',
    },
    {
        id: 3309,
        label: '문자 > OpenType > 표준 합자',
        placement: 'MenuBar',
        name: '표준 합자',
    },
    {
        id: 3310,
        label: '문자 > OpenType > 고전 스타일',
        placement: 'MenuBar',
        name: '고전 스타일',
    },
    {
        id: 3327,
        label: '문자 > OpenType > 메트릭(비례)',
        placement: 'MenuBar',
        name: '메트릭(비례)',
    },
    {
        id: 3334,
        label: '문자 > OpenType > 스와시',
        placement: 'MenuBar',
        name: '스와시',
    },
    {
        id: 3338,
        label: '문자 > OpenType > 상황에 맞는 대체물 사용',
        placement: 'MenuBar',
        name: '상황에 맞는 대체물 사용',
    },
    {
        id: 3339,
        label: '문자 > OpenType > 임의 합자',
        placement: 'MenuBar',
        name: '임의 합자',
    },
    {
        id: 3340,
        label: '문자 > OpenType > 스타일 대체',
        placement: 'MenuBar',
        name: '스타일 대체',
    },
    {
        id: 3341,
        label: '문자 > OpenType > 제목 대체',
        placement: 'MenuBar',
        name: '제목 대체',
    },
    {
        id: 3342,
        label: '문자 > OpenType > 장식',
        placement: 'MenuBar',
        name: '장식',
    },
    {
        id: 3343,
        label: '문자 > OpenType > 서수',
        placement: 'MenuBar',
        name: '서수',
    },
    {
        id: 3344,
        label: '문자 > OpenType > 분할',
        placement: 'MenuBar',
        name: '분할',
    },
    {
        id: 3345,
        label: '문자 > OpenType > 일본어 78',
        placement: 'MenuBar',
        name: '일본어 78',
    },
    {
        id: 3346,
        label: '문자 > OpenType > 일본어 전문가',
        placement: 'MenuBar',
        name: '일본어 전문가',
    },
    {
        id: 3347,
        label: '문자 > OpenType > 전통 일본어',
        placement: 'MenuBar',
        name: '전통 일본어',
    },
    {
        id: 3348,
        label: '문자 > OpenType > 가나',
        placement: 'MenuBar',
        name: '가나',
    },
    {
        id: 3349,
        label: '문자 > OpenType > 로마자 이탤릭체',
        placement: 'MenuBar',
        name: '로마자 이탤릭체',
    },
    {
        id: 3350,
        label: '문자 > 패널 > 단락 패널',
        placement: 'MenuBar',
        name: '단락 패널',
    },
    {
        id: 3350,
        label: '창 > 단락',
        placement: 'MenuBar',
        name: '단락',
    },
    {
        id: 3370,
        label: '문자 > 앤티 앨리어스 > 없음',
        placement: 'MenuBar',
        name: '없음',
    },
    {
        id: 3371,
        label: '문자 > 앤티 앨리어스 > 뚜렷하게',
        placement: 'MenuBar',
        name: '뚜렷하게',
    },
    {
        id: 3372,
        label: '문자 > 앤티 앨리어스 > 강하게',
        placement: 'MenuBar',
        name: '강하게',
    },
    {
        id: 3373,
        label: '문자 > 앤티 앨리어스 > 매끄럽게',
        placement: 'MenuBar',
        name: '매끄럽게',
    },
    {
        id: 3374,
        label: '문자 > 앤티 앨리어스 > 선명하게',
        placement: 'MenuBar',
        name: '선명하게',
    },
    {
        id: 3375,
        label: '문자 > 앤티 앨리어스 > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: '문자 > 앤티 앨리어스 > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: '문자 > 텍스트 모양 유형 변환',
        placement: 'MenuBar',
        name: '텍스트 모양 유형 변환',
    },
    {
        id: 3390,
        label: '문자 > 모든 텍스트 레이어 업데이트',
        placement: 'MenuBar',
        name: '모든 텍스트 레이어 업데이트',
    },
    {
        id: 3392,
        label: '편집 > 맞춤법 검사...',
        placement: 'MenuBar',
        name: '맞춤법 검사...',
    },
    {
        id: 3393,
        label: '편집 > 텍스트 찾기/바꾸기...',
        placement: 'MenuBar',
        name: '텍스트 찾기/바꾸기...',
    },
    {
        id: 3409,
        label: '레이어 > 모양 결합 > 모양 통합',
        placement: 'MenuBar',
        name: '모양 통합',
    },
    {
        id: 3410,
        label: '레이어 > 모양 결합 > 전면 모양 빼기',
        placement: 'MenuBar',
        name: '전면 모양 빼기',
    },
    {
        id: 3411,
        label: '레이어 > 모양 결합 > 오버랩에서 모양 결합',
        placement: 'MenuBar',
        name: '오버랩에서 모양 결합',
    },
    {
        id: 3412,
        label: '레이어 > 모양 결합 > 오버랩에서 모양 빼기',
        placement: 'MenuBar',
        name: '오버랩에서 모양 빼기',
    },
    {
        id: 3438,
        label: '레이어 > SVG 복사',
        placement: 'MenuBar',
        name: 'SVG 복사',
    },
    {
        id: 3439,
        label: '레이어 > CSS 복사',
        placement: 'MenuBar',
        name: 'CSS 복사',
    },
    {
        id: 3443,
        label: '파일 > 내보내기 > 내보내기 형식...',
        placement: 'MenuBar',
        name: '내보내기 형식...',
    },
    {
        id: 3444,
        label: '파일 > 내보내기 > PNG으(로) 빠른 내보내기',
        placement: 'MenuBar',
        name: 'PNG으(로) 빠른 내보내기',
    },
    {
        id: 3446,
        label: '레이어 > PNG으(로) 빠른 내보내기',
        placement: 'MenuBar',
        name: 'PNG으(로) 빠른 내보내기',
    },
    {
        id: 3447,
        label: '레이어 > 내보내기 형식...',
        placement: 'MenuBar',
        name: '내보내기 형식...',
    },
    {
        id: 3451,
        label: '문자 > 언어 옵션 > LTR 아랍어 숫자 - 123%',
        placement: 'MenuBar',
        name: 'LTR 아랍어 숫자 - 123%',
    },
    {
        id: 3452,
        label: '문자 > 언어 옵션 > 페르시아어 숫자',
        placement: 'MenuBar',
        name: '페르시아어 숫자',
    },
    {
        id: 3453,
        label: '문자 > 언어 옵션 > 힌디어 숫자',
        placement: 'MenuBar',
        name: '힌디어 숫자',
    },
    {
        id: 3459,
        label: '문자 > 언어 옵션 > RTL 아랍어 숫자 - %123',
        placement: 'MenuBar',
        name: 'RTL 아랍어 숫자 - %123',
    },
    {
        id: 3500,
        label: '보기 > 표시자',
        placement: 'MenuBar',
        name: '표시자',
    },
    {
        id: 3501,
        label: '보기 > 표시 > 선택 영역 가장자리(S)',
        placement: 'MenuBar',
        name: '선택 영역 가장자리(S)',
    },
    {
        id: 3502,
        label: '보기 > 표시 > 대상 패스(P)',
        placement: 'MenuBar',
        name: '대상 패스(P)',
    },
    {
        id: 3503,
        label: '보기 > 표시 > 안내선',
        placement: 'MenuBar',
        name: '안내선',
    },
    {
        id: 3504,
        label: '보기 > 표시 > 격자(G)',
        placement: 'MenuBar',
        name: '격자(G)',
    },
    {
        id: 3505,
        label: '보기 > 표시 > 분할 영역(L)',
        placement: 'MenuBar',
        name: '분할 영역(L)',
    },
    {
        id: 3506,
        label: '보기 > 표시 > 메모(O)',
        placement: 'MenuBar',
        name: '메모(O)',
    },
    {
        id: 3507,
        label: '보기 > 표시 > 모두',
        placement: 'MenuBar',
        name: '모두',
    },
    {
        id: 3508,
        label: '보기 > 표시 > 없음',
        placement: 'MenuBar',
        name: '없음',
    },
    {
        id: 3510,
        label: '보기 > 표시 > 표시자 옵션 표시...',
        placement: 'MenuBar',
        name: '표시자 옵션 표시...',
    },
    {
        id: 3511,
        label: '보기 > 표시 > 스마트 가이드(M)',
        placement: 'MenuBar',
        name: '스마트 가이드(M)',
    },
    {
        id: 3512,
        label: '보기 > 표시 > 레이어 가장자리(E)',
        placement: 'MenuBar',
        name: '레이어 가장자리(E)',
    },
    {
        id: 3513,
        label: '보기 > 표시 > 개수(C)',
        placement: 'MenuBar',
        name: '개수(C)',
    },
    {
        id: 3514,
        label: '보기 > 표시 > 픽셀 격자(X)',
        placement: 'MenuBar',
        name: '픽셀 격자(X)',
    },
    {
        id: 3517,
        label: '보기 > 표시 > 메시(H)',
        placement: 'MenuBar',
        name: '메시(H)',
    },
    {
        id: 3520,
        label: '보기 > 스냅',
        placement: 'MenuBar',
        name: '스냅',
    },
    {
        id: 3521,
        label: '보기 > 스냅 옵션 > 안내선',
        placement: 'MenuBar',
        name: '안내선',
    },
    {
        id: 3522,
        label: '보기 > 스냅 옵션 > 격자',
        placement: 'MenuBar',
        name: '격자',
    },
    {
        id: 3523,
        label: '보기 > 스냅 옵션 > 분할 영역',
        placement: 'MenuBar',
        name: '분할 영역',
    },
    {
        id: 3524,
        label: '보기 > 스냅 옵션 > 문서 경계',
        placement: 'MenuBar',
        name: '문서 경계',
    },
    {
        id: 3527,
        label: '보기 > 스냅 옵션 > 모두',
        placement: 'MenuBar',
        name: '모두',
    },
    {
        id: 3528,
        label: '보기 > 스냅 옵션 > 없음',
        placement: 'MenuBar',
        name: '없음',
    },
    {
        id: 3530,
        label: '보기 > 스냅 옵션 > 레이어',
        placement: 'MenuBar',
        name: '레이어',
    },
    {
        id: 3532,
        label: '보기 > 표시 > 패턴 미리 보기 타일 테두리',
        placement: 'MenuBar',
        name: '패턴 미리 보기 타일 테두리',
    },
    {
        id: 3533,
        label: '보기 > 표시 > 아트보드 안내선',
        placement: 'MenuBar',
        name: '아트보드 안내선',
    },
    {
        id: 3535,
        label: '보기 > 표시 > 아트보드 이름',
        placement: 'MenuBar',
        name: '아트보드 이름',
    },
    {
        id: 3536,
        label: '보기 > 표시 > 캔버스 안내선',
        placement: 'MenuBar',
        name: '캔버스 안내선',
    },
    {
        id: 3541,
        label: '레이어 > 래스터화 > 모양',
        placement: 'MenuBar',
        name: '모양',
    },
    {
        id: 3542,
        label: '레이어 > 래스터화 > 문자',
        placement: 'MenuBar',
        name: '문자',
    },
    {
        id: 3542,
        label: '문자 > 문자 레이어 래스터화',
        placement: 'MenuBar',
        name: '문자 레이어 래스터화',
    },
    {
        id: 3544,
        label: '레이어 > 래스터화 > 칠 내용',
        placement: 'MenuBar',
        name: '칠 내용',
    },
    {
        id: 3545,
        label: '레이어 > 래스터화 > 모든 레이어',
        placement: 'MenuBar',
        name: '모든 레이어',
    },
    {
        id: 3547,
        label: '레이어 > 래스터화 > 레이어',
        placement: 'MenuBar',
        name: '레이어',
    },
    {
        id: 3549,
        label: '레이어 > 스마트 오브젝트 > 래스터화',
        placement: 'MenuBar',
        name: '래스터화',
    },
    {
        id: 3549,
        label: '레이어 > 래스터화 > 스마트 오브젝트',
        placement: 'MenuBar',
        name: '스마트 오브젝트',
    },
    {
        id: 3551,
        label: '레이어 > 래스터화 > 비디오',
        placement: 'MenuBar',
        name: '비디오',
    },
    {
        id: 3553,
        label: '레이어 > 래스터화 > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: '레이어 > 비디오 레이어 > 래스터화',
        placement: 'MenuBar',
        name: '래스터화',
    },
    {
        id: 3557,
        label: '레이어 > 래스터화 > 레이어 스타일',
        placement: 'MenuBar',
        name: '레이어 스타일',
    },
    {
        id: 3561,
        label: '레이어 > 래스터화 > 생성형',
        placement: 'MenuBar',
        name: '생성형',
    },
    {
        id: 3585,
        label: '보기 > 표시 > 핀 편집',
        placement: 'MenuBar',
        name: '핀 편집',
    },
    {
        id: 3911,
        label: '필터 > NextGen 필터 > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: '도움말 > 업데이트...',
        placement: 'MenuBar',
        name: '업데이트...',
    },
    {
        id: 4210,
        label: '창 > 도구 사전 설정',
        placement: 'MenuBar',
        name: '도구 사전 설정',
    },
    {
        id: 5059,
        label: '레이어 > 레이어 마스크 > 삭제',
        placement: 'MenuBar',
        name: '삭제',
    },
    {
        id: 5068,
        label: '편집 > 특수 붙여넣기 > 바깥쪽에 붙여넣기',
        placement: 'MenuBar',
        name: '바깥쪽에 붙여넣기',
    },
    {
        id: 5069,
        label: '선택 > 빠른 마스크 모드로 편집',
        placement: 'MenuBar',
        name: '빠른 마스크 모드로 편집',
    },
    {
        id: 5085,
        label: '레이어 > 레이어 마스크 > 연결',
        placement: 'MenuBar',
        name: '연결',
    },
    {
        id: 5095,
        label: '레이어 > 레이어 마스크 > 적용',
        placement: 'MenuBar',
        name: '적용',
    },
    {
        id: 5115,
        label: '창 > 작업 영역 > 새 작업 영역(N)...',
        placement: 'MenuBar',
        name: '새 작업 영역(N)...',
    },
    {
        id: 5116,
        label: '창 > 작업 영역 > 작업 영역 삭제(D)...',
        placement: 'MenuBar',
        name: '작업 영역 삭제(D)...',
    },
    {
        id: 5117,
        label: '창 > 작업 영역 > 필수 재설정(R)',
        placement: 'MenuBar',
        name: '필수 재설정(R)',
    },
    {
        id: 5217,
        label: '레이어 > 레이어 기반 새 분할 영역',
        placement: 'MenuBar',
        name: '레이어 기반 새 분할 영역',
    },
    {
        id: 5226,
        label: '레이어 > 스마트 필터 > 필터 마스크 삭제',
        placement: 'MenuBar',
        name: '필터 마스크 삭제',
    },
    {
        id: 5613,
        label: '보기 > 안내선 > 새 안내선...',
        placement: 'MenuBar',
        name: '새 안내선...',
    },
    {
        id: 5614,
        label: '보기 > 안내선 > 새 안내선 레이아웃...',
        placement: 'MenuBar',
        name: '새 안내선 레이아웃...',
    },
    {
        id: 5615,
        label: '보기 > 안내선 > 모양에서 새 안내선',
        placement: 'MenuBar',
        name: '모양에서 새 안내선',
    },
    {
        id: 5624,
        label: '편집 > 사용자 정의 모양 정의...',
        placement: 'MenuBar',
        name: '사용자 정의 모양 정의...',
    },
    {
        id: 5634,
        label: '창 > 작업 영역 > 필수(기본값)(E)',
        placement: 'MenuBar',
        name: '필수(기본값)(E)',
    },
    {
        id: 5929,
        label: '창 > 정돈 > 모두 맨 앞으로 가져오기',
        placement: 'MenuBar',
        name: '모두 맨 앞으로 가져오기',
    },
    {
        id: 5930,
        label: '창 > 정돈 > 겹쳐 놓기',
        placement: 'MenuBar',
        name: '겹쳐 놓기',
    },
    {
        id: 5931,
        label: '창 > 정돈 > 나란히 놓기',
        placement: 'MenuBar',
        name: '나란히 놓기',
    },
    {
        id: 5932,
        label: '창 > 정돈 > 최소화',
        placement: 'MenuBar',
        name: '최소화',
    },
    {
        id: 5933,
        label: '창 > 정돈 > 모두 수직으로 나란히 놓기',
        placement: 'MenuBar',
        name: '모두 수직으로 나란히 놓기',
    },
    {
        id: 5934,
        label: '창 > 정돈 > 모두 수평으로 나란히 놓기',
        placement: 'MenuBar',
        name: '모두 수평으로 나란히 놓기',
    },
    {
        id: 5935,
        label: '창 > 정돈 > 2장 가로',
        placement: 'MenuBar',
        name: '2장 가로',
    },
    {
        id: 5936,
        label: '창 > 정돈 > 2장 세로',
        placement: 'MenuBar',
        name: '2장 세로',
    },
    {
        id: 5937,
        label: '창 > 정돈 > 3장 가로',
        placement: 'MenuBar',
        name: '3장 가로',
    },
    {
        id: 5938,
        label: '창 > 정돈 > 3장 세로',
        placement: 'MenuBar',
        name: '3장 세로',
    },
    {
        id: 5939,
        label: '창 > 정돈 > 3장 스택형',
        placement: 'MenuBar',
        name: '3장 스택형',
    },
    {
        id: 5940,
        label: '창 > 정돈 > 4장',
        placement: 'MenuBar',
        name: '4장',
    },
    {
        id: 5941,
        label: '창 > 정돈 > 6장',
        placement: 'MenuBar',
        name: '6장',
    },
    {
        id: 5956,
        label: '도움말 > Photoshop 도움말...',
        placement: 'MenuBar',
        name: 'Photoshop 도움말...',
    },
    {
        id: 5957,
        label: '편집 > 검색',
        placement: 'MenuBar',
        name: '검색',
    },
    {
        id: 5960,
        label: '창 > 정돈 > 확대/축소 일치',
        placement: 'MenuBar',
        name: '확대/축소 일치',
    },
    {
        id: 5962,
        label: '창 > 정돈 > 위치 일치',
        placement: 'MenuBar',
        name: '위치 일치',
    },
    {
        id: 5963,
        label: '창 > 정돈 > 회전 일치',
        placement: 'MenuBar',
        name: '회전 일치',
    },
    {
        id: 5964,
        label: '창 > 정돈 > 모두 일치',
        placement: 'MenuBar',
        name: '모두 일치',
    },
    {
        id: 5966,
        label: '파일 > 검토용으로 공유',
        placement: 'MenuBar',
        name: '검토용으로 공유',
    },
    {
        id: 5967,
        label: '파일 > 편집하도록 초대...',
        placement: 'MenuBar',
        name: '편집하도록 초대...',
    },
    {
        id: 5968,
        label: '파일 > 내보내기 > Firefly 보드로 보내기',
        placement: 'MenuBar',
        name: 'Firefly 보드로 보내기',
    },
    {
        id: 5980,
        label: '편집 > 바로 가기 키...',
        placement: 'MenuBar',
        name: '바로 가기 키...',
    },
    {
        id: 5981,
        label: '창 > 작업 영역 > 바로 가기 키 및 메뉴(K)...',
        placement: 'MenuBar',
        name: '바로 가기 키 및 메뉴(K)...',
    },
    {
        id: 5982,
        label: '편집 > 메뉴...',
        placement: 'MenuBar',
        name: '메뉴...',
    },
    {
        id: 5983,
        label: '편집 > 도구 모음...',
        placement: 'MenuBar',
        name: '도구 모음...',
    },
    {
        id: 5991,
        label: '보기 > 화면 모드 > 표준 화면 모드',
        placement: 'MenuBar',
        name: '표준 화면 모드',
    },
    {
        id: 5992,
        label: '보기 > 화면 모드 > 메뉴 막대가 있는 전체 화면 모드',
        placement: 'MenuBar',
        name: '메뉴 막대가 있는 전체 화면 모드',
    },
    {
        id: 5993,
        label: '보기 > 화면 모드 > 전체 화면 모드',
        placement: 'MenuBar',
        name: '전체 화면 모드',
    },
    {
        id: 5996,
        label: '창 > 정돈 > 창에서 유동',
        placement: 'MenuBar',
        name: '창에서 유동',
    },
    {
        id: 5997,
        label: '창 > 정돈 > 모두 창에서 유동',
        placement: 'MenuBar',
        name: '모두 창에서 유동',
    },
    {
        id: 5998,
        label: '창 > 정돈 > 모두 탭에 통합',
        placement: 'MenuBar',
        name: '모두 탭에 통합',
    },
    {
        id: 6300,
        label: '레이어 > 새 칠 레이어 > 단색...',
        placement: 'MenuBar',
        name: '단색...',
    },
    {
        id: 6301,
        label: '레이어 > 새 칠 레이어 > 그레이디언트...',
        placement: 'MenuBar',
        name: '그레이디언트...',
    },
    {
        id: 6302,
        label: '레이어 > 새 칠 레이어 > 패턴...',
        placement: 'MenuBar',
        name: '패턴...',
    },
    {
        id: 6303,
        label: '레이어 > 새 조정 레이어 > 레벨...',
        placement: 'MenuBar',
        name: '레벨...',
    },
    {
        id: 6304,
        label: '레이어 > 새 조정 레이어 > 곡선...',
        placement: 'MenuBar',
        name: '곡선...',
    },
    {
        id: 6305,
        label: '레이어 > 새 조정 레이어 > 색상 균형...',
        placement: 'MenuBar',
        name: '색상 균형...',
    },
    {
        id: 6306,
        label: '레이어 > 새 조정 레이어 > 밝기/대비...',
        placement: 'MenuBar',
        name: '밝기/대비...',
    },
    {
        id: 6308,
        label: '레이어 > 새 조정 레이어 > 색조/채도...',
        placement: 'MenuBar',
        name: '색조/채도...',
    },
    {
        id: 6309,
        label: '레이어 > 새 조정 레이어 > 선택 색상...',
        placement: 'MenuBar',
        name: '선택 색상...',
    },
    {
        id: 6310,
        label: '레이어 > 새 조정 레이어 > 채널 혼합...',
        placement: 'MenuBar',
        name: '채널 혼합...',
    },
    {
        id: 6311,
        label: '레이어 > 새 조정 레이어 > 그레이디언트 맵...',
        placement: 'MenuBar',
        name: '그레이디언트 맵...',
    },
    {
        id: 6312,
        label: '레이어 > 새 조정 레이어 > 포토 필터...',
        placement: 'MenuBar',
        name: '포토 필터...',
    },
    {
        id: 6313,
        label: '레이어 > 새 조정 레이어 > 반전...',
        placement: 'MenuBar',
        name: '반전...',
    },
    {
        id: 6314,
        label: '레이어 > 새 조정 레이어 > 한계값...',
        placement: 'MenuBar',
        name: '한계값...',
    },
    {
        id: 6315,
        label: '레이어 > 새 조정 레이어 > 포스터화...',
        placement: 'MenuBar',
        name: '포스터화...',
    },
    {
        id: 6332,
        label: '레이어 > 스마트 오브젝트 > 내용 편집',
        placement: 'MenuBar',
        name: '내용 편집',
    },
    {
        id: 6333,
        label: '레이어 > 스마트 오브젝트 > 내용 대체...',
        placement: 'MenuBar',
        name: '내용 대체...',
    },
    {
        id: 6334,
        label: '레이어 > 스마트 오브젝트 > 내용 내보내기...',
        placement: 'MenuBar',
        name: '내용 내보내기...',
    },
    {
        id: 6337,
        label: '레이어 > 새 조정 레이어 > 색상 검색...',
        placement: 'MenuBar',
        name: '색상 검색...',
    },
    {
        id: 6339,
        label: '레이어 > 스마트 오브젝트 > 연결됨으로 변환...',
        placement: 'MenuBar',
        name: '연결됨으로 변환...',
    },
    {
        id: 6340,
        label: '레이어 > 스마트 오브젝트 > 파일에 재연결...',
        placement: 'MenuBar',
        name: '파일에 재연결...',
    },
    {
        id: 6341,
        label: '레이어 > 스마트 오브젝트 > 라이브러리 그래픽에 재연결...',
        placement: 'MenuBar',
        name: '라이브러리 그래픽에 재연결...',
    },
    {
        id: 6342,
        label: '레이어 > 스마트 오브젝트 > 수정된 내용 업데이트',
        placement: 'MenuBar',
        name: '수정된 내용 업데이트',
    },
    {
        id: 6343,
        label: '레이어 > 스마트 오브젝트 > 모든 수정된 내용 업데이트',
        placement: 'MenuBar',
        name: '모든 수정된 내용 업데이트',
    },
    {
        id: 6345,
        label: '레이어 > 스마트 오브젝트 > 포함된 연결',
        placement: 'MenuBar',
        name: '포함된 연결',
    },
    {
        id: 6346,
        label: '레이어 > 스마트 오브젝트 > 포함된 모든 연결 개체',
        placement: 'MenuBar',
        name: '포함된 모든 연결 개체',
    },
    {
        id: 6347,
        label: '레이어 > 스마트 오브젝트 > 변형 재설정',
        placement: 'MenuBar',
        name: '변형 재설정',
    },
    {
        id: 6348,
        label: '레이어 > 새 조정 레이어 > 흑백...',
        placement: 'MenuBar',
        name: '흑백...',
    },
    {
        id: 6351,
        label: '레이어 > 비디오 레이어 > 파일에서 비디오 레이어 새로 만들기...',
        placement: 'MenuBar',
        name: '파일에서 비디오 레이어 새로 만들기...',
    },
    {
        id: 6352,
        label: '레이어 > 비디오 레이어 > 새 빈 비디오 레이어',
        placement: 'MenuBar',
        name: '새 빈 비디오 레이어',
    },
    {
        id: 6353,
        label: '레이어 > 비디오 레이어 > 빈 프레임 삽입',
        placement: 'MenuBar',
        name: '빈 프레임 삽입',
    },
    {
        id: 6354,
        label: '레이어 > 비디오 레이어 > 프레임 복제',
        placement: 'MenuBar',
        name: '프레임 복제',
    },
    {
        id: 6355,
        label: '레이어 > 비디오 레이어 > 프레임 삭제',
        placement: 'MenuBar',
        name: '프레임 삭제',
    },
    {
        id: 6356,
        label: '레이어 > 비디오 레이어 > 푸티지 해석...',
        placement: 'MenuBar',
        name: '푸티지 해석...',
    },
    {
        id: 6357,
        label: '레이어 > 비디오 레이어 > 푸티지 바꾸기...',
        placement: 'MenuBar',
        name: '푸티지 바꾸기...',
    },
    {
        id: 6358,
        label: '레이어 > 비디오 레이어 > 변경된 비디오 표시',
        placement: 'MenuBar',
        name: '변경된 비디오 표시',
    },
    {
        id: 6360,
        label: '레이어 > 비디오 레이어 > 프레임 복원',
        placement: 'MenuBar',
        name: '프레임 복원',
    },
    {
        id: 6361,
        label: '레이어 > 비디오 레이어 > 모든 프레임 복원',
        placement: 'MenuBar',
        name: '모든 프레임 복원',
    },
    {
        id: 6362,
        label: '파일 > 가져오기 > 비디오 프레임을 레이어로...',
        placement: 'MenuBar',
        name: '비디오 프레임을 레이어로...',
    },
    {
        id: 6363,
        label: '레이어 > 비디오 레이어 > 프레임 다시 불러오기',
        placement: 'MenuBar',
        name: '프레임 다시 불러오기',
    },
    {
        id: 6400,
        label: '보기 > 32비트 미리 보기 옵션…',
        placement: 'MenuBar',
        name: '32비트 미리 보기 옵션…',
    },
    {
        id: 6432,
        label: '레이어 > 스마트 오브젝트 > 스택 모드 > 없음',
        placement: 'MenuBar',
        name: '없음',
    },
    {
        id: 6440,
        label: '필터 > 스마트 필터용으로 변환',
        placement: 'MenuBar',
        name: '스마트 필터용으로 변환',
    },
    {
        id: 6478,
        label: '창 > 속성',
        placement: 'MenuBar',
        name: '속성',
    },
    {
        id: 6479,
        label: '창 > 조정',
        placement: 'MenuBar',
        name: '조정',
    },
    {
        id: 6651,
        label: '레이어 > 새 조정 레이어 > 선명도 및 디헤이즈…',
        placement: 'MenuBar',
        name: '선명도 및 디헤이즈…',
    },
    {
        id: 6652,
        label: '레이어 > 새 조정 레이어 > 그레인…',
        placement: 'MenuBar',
        name: '그레인…',
    },
    {
        id: 7763,
        label: '창 > 그레이디언트',
        placement: 'MenuBar',
        name: '그레이디언트',
    },
    {
        id: 7767,
        label: '창 > 패턴',
        placement: 'MenuBar',
        name: '패턴',
    },
    {
        id: 7772,
        label: '창 > 모양',
        placement: 'MenuBar',
        name: '모양',
    },
    {
        id: 7785,
        label: '창 > Content Credentials(Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials(Beta)',
    },
    {
        id: 7788,
        label: '창 > 질감',
        placement: 'MenuBar',
        name: '질감',
    },
    {
        id: 7789,
        label: '필터 > 매개 변수 필터...',
        placement: 'MenuBar',
        name: '매개 변수 필터...',
    },
    {
        id: 7800,
        label: '이미지 > 데이터 세트 적용...',
        placement: 'MenuBar',
        name: '데이터 세트 적용...',
    },
    {
        id: 7802,
        label: '이미지 > 변수 > 정의...',
        placement: 'MenuBar',
        name: '정의...',
    },
    {
        id: 7803,
        label: '이미지 > 변수 > 데이터 세트...',
        placement: 'MenuBar',
        name: '데이터 세트...',
    },
    {
        id: 7805,
        label: '파일 > 가져오기 > 변수 데이터 세트...',
        placement: 'MenuBar',
        name: '변수 데이터 세트...',
    },
    {
        id: 7806,
        label: '파일 > 내보내기 > 데이터 세트를 파일로 저장...',
        placement: 'MenuBar',
        name: '데이터 세트를 파일로 저장...',
    },
    {
        id: 7900,
        label: '이미지 > 분석 > 카운트 도구',
        placement: 'MenuBar',
        name: '카운트 도구',
    },
    {
        id: 7930,
        label: '창 > 응용 프로그램 프레임',
        placement: 'MenuBar',
        name: '응용 프로그램 프레임',
    },
    {
        id: 8820,
        label: '필터 > 뉴럴 필터...',
        placement: 'MenuBar',
        name: '뉴럴 필터...',
    },
    {
        id: 9066,
        label: '문자 > 패널 > 문자 스타일 패널',
        placement: 'MenuBar',
        name: '문자 스타일 패널',
    },
    {
        id: 9066,
        label: '창 > 문자 스타일',
        placement: 'MenuBar',
        name: '문자 스타일',
    },
    {
        id: 9067,
        label: '문자 > 패널 > 단락 스타일 패널',
        placement: 'MenuBar',
        name: '단락 스타일 패널',
    },
    {
        id: 9067,
        label: '창 > 단락 스타일',
        placement: 'MenuBar',
        name: '단락 스타일',
    },
    {
        id: 9068,
        label: '문자 > 패널 > 글리프 패널',
        placement: 'MenuBar',
        name: '글리프 패널',
    },
    {
        id: 9068,
        label: '창 > 글리프',
        placement: 'MenuBar',
        name: '글리프',
    },
    {
        id: 9086,
        label: '문자 > OpenType > 양쪽 정렬 대체',
        placement: 'MenuBar',
        name: '양쪽 정렬 대체',
    },
    {
        id: 9087,
        label: '문자 > 누락된 글꼴 관리',
        placement: 'MenuBar',
        name: '누락된 글꼴 관리',
    },
    {
        id: 9100,
        label: '문자 > 언어 옵션 > 기본 기능',
        placement: 'MenuBar',
        name: '기본 기능',
    },
    {
        id: 9101,
        label: '문자 > 언어 옵션 > 동아시아 기능',
        placement: 'MenuBar',
        name: '동아시아 기능',
    },
    {
        id: 9102,
        label: '문자 > 언어 옵션 > 중동 언어 기능',
        placement: 'MenuBar',
        name: '중동 언어 기능',
    },
    {
        id: 9109,
        label: '문자 > 글꼴 미리 보기 크기 > 없음',
        placement: 'MenuBar',
        name: '없음',
    },
    {
        id: 9110,
        label: '문자 > 글꼴 미리 보기 크기 > 소',
        placement: 'MenuBar',
        name: '소',
    },
    {
        id: 9111,
        label: '문자 > 글꼴 미리 보기 크기 > 중',
        placement: 'MenuBar',
        name: '중',
    },
    {
        id: 9112,
        label: '문자 > 글꼴 미리 보기 크기 > 대',
        placement: 'MenuBar',
        name: '대',
    },
    {
        id: 9113,
        label: '문자 > 글꼴 미리 보기 크기 > 특대',
        placement: 'MenuBar',
        name: '특대',
    },
    {
        id: 9114,
        label: '문자 > 글꼴 미리 보기 크기 > 거대',
        placement: 'MenuBar',
        name: '거대',
    },
    {
        id: 9119,
        label: '문자 > Lorem Ipsum 붙여넣기',
        placement: 'MenuBar',
        name: 'Lorem Ipsum 붙여넣기',
    },
    {
        id: 9121,
        label: '문자 > 기본 문자 스타일 불러오기',
        placement: 'MenuBar',
        name: '기본 문자 스타일 불러오기',
    },
    {
        id: 9122,
        label: '문자 > 기본 유형 스타일 저장',
        placement: 'MenuBar',
        name: '기본 유형 스타일 저장',
    },
    {
        id: 9123,
        label: '문자 > 일치하는 글꼴...',
        placement: 'MenuBar',
        name: '일치하는 글꼴...',
    },
    {
        id: 9130,
        label: '문자 > 언어 옵션 > 로마자 표준 세로 맞춤',
        placement: 'MenuBar',
        name: '로마자 표준 세로 맞춤',
    },
    {
        id: 9131,
        label: '문자 > 언어 옵션 > 문자 회전',
        placement: 'MenuBar',
        name: '문자 회전',
    },
    {
        id: 9132,
        label: '문자 > 언어 옵션 > 문자 상단선 기준 행간',
        placement: 'MenuBar',
        name: '문자 상단선 기준 행간',
    },
    {
        id: 9133,
        label: '문자 > 언어 옵션 > 기준선 기준 행간',
        placement: 'MenuBar',
        name: '기준선 기준 행간',
    },
    {
        id: 9137,
        label: '문자 > 언어 옵션 > 카시다',
        placement: 'MenuBar',
        name: '카시다',
    },
    {
        id: 9138,
        label: '문자 > 언어 옵션 > 기본 방향',
        placement: 'MenuBar',
        name: '기본 방향',
    },
    {
        id: 9139,
        label: '문자 > 언어 옵션 > 왼쪽에서 오른쪽 문자 방향',
        placement: 'MenuBar',
        name: '왼쪽에서 오른쪽 문자 방향',
    },
    {
        id: 9140,
        label: '문자 > 언어 옵션 > 오른쪽에서 왼쪽 문자 방향',
        placement: 'MenuBar',
        name: '오른쪽에서 왼쪽 문자 방향',
    },
    {
        id: 9143,
        label: '편집 > 특수 붙여넣기 > 형식 없이 붙여넣기',
        placement: 'MenuBar',
        name: '형식 없이 붙여넣기',
    },
    {
        id: 9220,
        label: '레이어 > 새로 만들기 > 아트보드...',
        placement: 'MenuBar',
        name: '아트보드...',
    },
    {
        id: 9221,
        label: '레이어 > 새로 만들기 > 그룹에서 아트보드',
        placement: 'MenuBar',
        name: '그룹에서 아트보드',
    },
    {
        id: 9222,
        label: '레이어 > 새로 만들기 > 레이어에서 아트보드...',
        placement: 'MenuBar',
        name: '레이어에서 아트보드...',
    },
    {
        id: 9252,
        label: '레이어 > 새로 만들기 > 레이어에서 프레임...',
        placement: 'MenuBar',
        name: '레이어에서 프레임...',
    },
    {
        id: 9255,
        label: '레이어 > 새로 만들기 > 프레임으로 변환',
        placement: 'MenuBar',
        name: '프레임으로 변환',
    },
    {
        id: 9600,
        label: '창 > 상황별 작업 표시줄',
        placement: 'MenuBar',
        name: '상황별 작업 표시줄',
    },
    {
        id: 11600,
        label: '레이어 > 하모나이즈',
        placement: 'MenuBar',
        name: '하모나이즈',
    },
    {
        id: 15004,
        label: '도움말 > 시스템 정보...',
        placement: 'MenuBar',
        name: '시스템 정보...',
    },
    {
        id: 15009,
        label: '도움말 > GPU 호환성...',
        placement: 'MenuBar',
        name: 'GPU 호환성...',
    },
    {
        id: 15019,
        label: '도움말 > 생성형 크레딧에 대해 자세히 알아보기',
        placement: 'MenuBar',
        name: '생성형 크레딧에 대해 자세히 알아보기',
    },
    {
        id: 15020,
        label: '도움말 > Adobe 생성형 AI 사용자 지침',
        placement: 'MenuBar',
        name: 'Adobe 생성형 AI 사용자 지침',
    },
    {
        id: 15201,
        label: '파일 > Adobe Stock 검색...',
        placement: 'MenuBar',
        name: 'Adobe Stock 검색...',
    },
    {
        id: 15202,
        label: '파일 > Adobe Express 템플릿 검색...',
        placement: 'MenuBar',
        name: 'Adobe Express 템플릿 검색...',
    },
    {
        id: 15203,
        label: '도움말 > 실습 튜토리얼...',
        placement: 'MenuBar',
        name: '실습 튜토리얼...',
    },
    {
        id: 15204,
        label: '도움말 > 새로운 기능...',
        placement: 'MenuBar',
        name: '새로운 기능...',
    },
    {
        id: 17001,
        label: '편집 > 원근 뒤틀기',
        placement: 'MenuBar',
        name: '원근 뒤틀기',
    },
    {
        id: 20006,
        label: '파일 > 버전 기록',
        placement: 'MenuBar',
        name: '버전 기록',
    },
    {
        id: 20007,
        label: '창 > 버전 기록',
        placement: 'MenuBar',
        name: '버전 기록',
    },
    {
        id: 20008,
        label: '창 > 주석',
        placement: 'MenuBar',
        name: '주석',
    },
    {
        id: 21000,
        label: '레이어 > 스마트 오브젝트 > 레이어로 변환',
        placement: 'MenuBar',
        name: '레이어로 변환',
    },
    {
        id: 21001,
        label: '보기 > 화면 크기에 레이어 맞추기',
        placement: 'MenuBar',
        name: '화면 크기에 레이어 맞추기',
    },
    {
        id: 22003,
        label: '보기 > 안내선 > 선택한 안내선 편집',
        placement: 'MenuBar',
        name: '선택한 안내선 편집',
    },
    {
        id: 22004,
        label: '보기 > 안내선 > 선택한 안내선 지우기',
        placement: 'MenuBar',
        name: '선택한 안내선 지우기',
    },
    {
        id: 22100,
        label: '레이어 > 모든 개체 마스크',
        placement: 'MenuBar',
        name: '모든 개체 마스크',
    },
    {
        id: 23150,
        label: '필터 > 마지막 필터',
        placement: 'MenuBar',
        name: '마지막 필터',
    },
    {
        id: 23151,
        label: '필터 > 마지막 필터',
        placement: 'MenuBar',
        name: '마지막 필터',
    },
    {
        id: 23152,
        label: '필터 > 마지막 필터',
        placement: 'MenuBar',
        name: '마지막 필터',
    },
    {
        id: 23153,
        label: '필터 > 마지막 필터',
        placement: 'MenuBar',
        name: '마지막 필터',
    },
    {
        id: 25070,
        label: '편집 > 오브젝트 회전',
        placement: 'MenuBar',
        name: '오브젝트 회전',
    },
    {
        id: 26010,
        label: '편집 > 반사 제거…',
        placement: 'MenuBar',
        name: '반사 제거…',
    },
    {
        id: 30900,
        label: '파일 > 무료 Adobe Stock 이미지 배치…',
        placement: 'MenuBar',
        name: '무료 Adobe Stock 이미지 배치…',
    },
    {
        id: 'paintbrushTool',
        label: '브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: '조정 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: '연필 도구',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: '색상 대체 도구',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: '혼합 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: '지우개 도구',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: '배경 지우개 도구',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: '복제 도장 도구',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: '패턴 도장 도구',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: '복구 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: '작업 내역 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: '미술 작업 내역 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: '손가락 도구',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: '흐림 효과 도구',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: '선명 효과 도구',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: '닷지 도구',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: '번 도구',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: '스폰지 도구',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: '적목 현상 도구',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: '사각형 선택 윤곽 도구',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: '타원형 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: '단일 행 선택 윤곽 도구',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: '단일 열 선택 윤곽 도구',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: '이동 도구',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: '아트보드 도구',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: '올가미 도구',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: '선택 영역 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: '개체 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: '다각형 올가미 도구',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: '자석 올가미 도구',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: '자동 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: '빠른 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: '자르기 도구',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: '원근 자르기 도구',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: '분할 영역 도구',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: '분할 영역 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: '자동 지우개 도구',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: '그레이디언트 도구',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: '페인트 통 도구',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: '패스 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: '패스 선택 도구',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: '펜 도구',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: '자유 형태 펜 도구',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: '곡률 펜 도구',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: '기준점 추가 도구',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: '기준점 삭제 도구',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: '기준점 변환 도구',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: '가로쓰기 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: '세로쓰기 문자 도구',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: '가로쓰기 마스크 도구',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: '세로쓰기 마스크 도구',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: '사각형 도구',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: '타원 도구',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: '삼각형 도구',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: '다각형 도구',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: '줄 도구',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: '사용자 정의 모양 도구',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: '별모양 도구',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: '프레임 도구',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: '스포이드 도구',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: '색상 샘플러 도구',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: '눈금자 도구',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: '메모 도구',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: '손 도구',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: '회전 보기 도구',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: '돋보기 도구',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: '패치 도구',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: '내용 인식 이동 도구',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: '스팟 복구 브러시 도구',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: '제거 도구',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: '도구 모음 편집...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: '카운트 도구',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: '액션',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: '그레이디언트',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: '스타일',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: '색상 견본',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: '패턴',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: '막대 그래프',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: '정보',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: '패스',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: '모양',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: '도구 사전 설정',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: '색상',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: '채널',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: '레이어',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: '레이어 구성 요소',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: '타임라인',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: '복제 원본',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: '측정 로그',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'HDR 미리보기',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: '작업 내역',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: '내비게이터',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: '문자',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: '단락',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: '문자 스타일',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: '단락 스타일',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: '글리프',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: '메모',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: '속성',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials(Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: '라이브러리',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: '주석',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: '컨텍스트 표시줄 : 동적 텍스트',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: '패널 : 동적 텍스트',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: '도구 : 동적 텍스트',
        placement: 'Option',
    },
];
